var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('h3',{staticClass:"text-primary lh-2"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-grey-dark"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }